import { useContext, useEffect, useState, useCallback, useRef } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import Swal from "sweetalert2";

import { Header, StyledDialog } from "../styles/GerenciamentoContrato";
import Chip from "../../../../components/basics/Chip";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import Btn from "../../../../components/buttons/Btn";
import SelectErp from "../../../../components/basics/SelectErp";
import { getPerfilTributarioDados } from "../../../../repositories/qerpapi/impostos/ImpostosRepository";
import { notify } from "../../../../utils/notify";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { appendPerfilToOptionsIfMissing } from "../utils/perfilTributarioUtils";

const ModalEdicaoCadastroServico = ({
  open,
  onClose,
  locationId,
  perfilTributarioOptions,
  setPerfilTributarioOptions,
  loadingPerfilTributario,
}) => {
  const {
    selectService,
    setSelectService,
    perfilTributarioLinhaModal,
    setPerfilTributarioLinhaModal,
    setItemsTable,
  } = useContext(GerenciamentoContratoContext);

  const { updateServicoCadastroPerfilTributario } =
    useGerenciamentoContratoController();

  const [perfilEdicaoLocal, setPerfilEdicaoLocal] = useState(null);
  const [salvandoEdicaoPerfil, setSalvandoEdicaoPerfil] = useState(false);
  const perfilContextoRef = useRef(perfilTributarioLinhaModal);
  perfilContextoRef.current = perfilTributarioLinhaModal;

  useEffect(() => {
    if (!open) return;
    const atual = perfilContextoRef.current;
    setPerfilEdicaoLocal(atual);
    if (atual?.id) {
      appendPerfilToOptionsIfMissing(setPerfilTributarioOptions, atual);
    }
  }, [open, setPerfilTributarioOptions]);

  const fechar = onClose;

  const aplicarPerfilSalvoNoContextoELista = useCallback(
    async (novoPerfil) => {
      const novoId = novoPerfil?.id ?? null;
      let detalhe = novoPerfil;
      if (novoId && !detalhe?.configuracaoNfse) {
        try {
          const response = await getPerfilTributarioDados(novoId);
          if (response && response.success !== false && response.descricao) {
            detalhe = response;
          }
        } catch (error) {
          console.error(
            "Erro ao carregar detalhes do perfil tributário:",
            error
          );
        }
      } else if (!novoId) {
        detalhe = null;
      }
      appendPerfilToOptionsIfMissing(setPerfilTributarioOptions, detalhe);
      setPerfilTributarioLinhaModal(detalhe || null);
      setSelectService((prev) =>
        prev
          ? {
              ...prev,
              perfil_tributario_id: novoId,
              perfil_tributario: detalhe,
            }
          : null
      );
      if (locationId >= 0) {
        setItemsTable((prev) => {
          if (!prev?.[locationId]) return prev;
          const copy = [...prev];
          const row = copy[locationId];
          copy[locationId] = {
            ...row,
            service: {
              ...row.service,
              perfil_tributario_id: novoId,
              perfil_tributario: detalhe,
            },
          };
          return copy;
        });
      }
    },
    [
      setPerfilTributarioLinhaModal,
      setPerfilTributarioOptions,
      setSelectService,
      setItemsTable,
      locationId,
    ]
  );

  const handleSalvar = useCallback(async () => {
    if (!selectService?.id) return;
    const novoId = perfilEdicaoLocal?.id ?? null;
    const antigoId = selectService?.perfil_tributario_id ?? null;
    if (novoId === antigoId) {
      fechar();
      return;
    }

    const result = await Swal.fire({
      title: "Atenção",
      text: "A alteração do perfil tributário será gravada no cadastro do serviço e passará a valer para os demais usos desse serviço. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceitar",
      cancelButtonText: "Cancelar",
    });
    if (!result.isConfirmed) return;

    setSalvandoEdicaoPerfil(true);
    try {
      const persist = await updateServicoCadastroPerfilTributario(
        selectService.id,
        novoId
      );
      if (!persist?.success) {
        notify("Erro ao salvar alteração do perfil tributário");
        return;
      }
      await aplicarPerfilSalvoNoContextoELista(perfilEdicaoLocal);
      fechar();
    } finally {
      setSalvandoEdicaoPerfil(false);
    }
  }, [
    selectService?.id,
    selectService?.perfil_tributario_id,
    perfilEdicaoLocal,
    updateServicoCadastroPerfilTributario,
    aplicarPerfilSalvoNoContextoELista,
    fechar,
  ]);

  return (
    <Dialog
      open={open}
      onClose={fechar}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
      aria-labelledby="dialog-edicao-cadastro-servico-title"
    >
      <StyledDialog>
        <DialogTitle id="dialog-edicao-cadastro-servico-title">
          <Header>
            <Grid container align="center" justifyContent="center">
              <Chip
                bgcolor="tertiary"
                textcolor="white"
                label="EDITAR CADASTRO DE SERVIÇO"
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContent>
          <SelectErp
            variant="filled"
            label="Perfil tributário"
            optionsList={perfilTributarioOptions}
            value={perfilEdicaoLocal}
            setValue={setPerfilEdicaoLocal}
            loading={loadingPerfilTributario}
            getOptionSelected={(option, value) =>
              option && value
                ? String(option.id) === String(value.id)
                : false
            }
            getOptionLabel={(option) => (option ? `${option.descricao}` : "")}
          />
        </DialogContent>
        <DialogActions>
          <Btn onClick={fechar} bgcolor="darkred" label="Cancelar" />
          <Btn
            onClick={handleSalvar}
            bgcolor="primary"
            label="Salvar"
            disabled={salvandoEdicaoPerfil}
          />
        </DialogActions>
      </StyledDialog>
    </Dialog>
  );
};

export { ModalEdicaoCadastroServico };
